import { qs, qsa, add } from "@fluorescent/dom";

import { section } from "@/glow";
import { getRecentProducts } from "@/lib/recently-viewed";
import ProductTile from "@/lib/product-tile";
import navigationDots from "@/lib/navigation-dots";
import { makeRequest } from "@/lib/xhr";

const {
  strings: { accessibility: strings },
} = window.theme;

const selectors = {
  settings: "[data-settings-data]",
  slider: "[data-slider]",
  recentlyViewed: ".recently-viewed__products",
  productTile: "[data-product-tile]",
  navigation: "[data-navigation]",
};

section("recently-viewed", {
  onLoad() {
    const { productCount, imageAspectRatio } = this.container.dataset;
    this.productCount = parseInt(productCount, 10);
    this.imageAspectRatio = imageAspectRatio;
    this.recentProductsContainer = qs(selectors.recentlyViewed, this.container);
    this.sliderNavigation = qs(selectors.navigation, this.container);
    this.sliderContainer = qs(selectors.slider, this.container);
    this.dotNavigation = null;

    // Grab products from localStorage
    const recentItems = getRecentProducts();

    if ((recentItems || []).length >= 3) {
      this._renderItems(recentItems);
      this._renderAccessibleDotNavigation(recentItems);
    }
  },

  _renderItems(items) {
    const recentItems = items.slice(0, this.productCount);

    const actions = recentItems.map(this._renderItem.bind(this));

    const results = Promise.all(actions);

    results.then(() => {
      import(flu.chunks.flickity).then(({ Flickity }) => {
        this.slider = new Flickity(this.sliderContainer, {
          adaptiveHeight: true,
          pageDots: false,
          prevNextButtons: false,
          watchCSS: true,
          wrapAround: false,
        });

        add(this.container, "visible");
        this.productTiles = qsa(selectors.productTile, this.container).map(
          tile => ProductTile(tile)
        );

        qsa(".recently-viewed__product", this.container).forEach(item => {
          if (this.imageAspectRatio !== "natural") {
            const classMod = "image-aspect-ratio--" + this.imageAspectRatio;
            add(item, "image-aspect-ratio", classMod);
          }
        });

        setTimeout(() => {
          this.slider.resize();
        }, 500);

        this.dotNavigation = navigationDots(this.container, this.slider);

        this.slider.on("select", () => {
          this.dotNavigation.update(this.slider.selectedIndex);
        });
      });
    });
  },

  _renderItem(item) {
    return new Promise(resolve => {
      const requestUrl = `${theme.routes.products}/${encodeURIComponent(
        item.handle
      )}?section_id=recently-viewed-item`;

      makeRequest("GET", requestUrl).then(response => {
        let container = document.createElement("div");
        container.innerHTML = response;

        const productTile = container.querySelector(
          "[data-recently-viewed-item]"
        ).innerHTML;

        this.recentProductsContainer.insertAdjacentHTML(
          "beforeend",
          productTile
        );
        resolve();
      });
    });
  },

  _renderAccessibleDotNavigation(items) {
    const html = `
      <div class="navigation-dots">
        <div class="navigation-dots__inner">
          ${items
            .slice(0, this.productCount)
            .map((_, i) => {
              const visibleClass = i === 0 ? "is-selected" : "";
              return `
              <button
                type="button"
                class="navigation-dot ${visibleClass}"
                data-slide-index="${i}"
                aria-label="${strings.carousel_select_js} ${i}"
              >
                <span class="navigation-dot__inner"></span>
              </button>
            `;
            })
            .join("")}
        </div>
      </div>
    `;

    this.sliderNavigation.insertAdjacentHTML("beforeend", html);
  },

  _destroy() {
    this.slider && this.slider.destroy();
    this.productTiles.forEach(tile => tile.unload());
  },

  onUnload() {
    this._destroy();
  },
});
